import { useEffect, useState } from "react";
import sseConsumer, { EventData, OperationStatusEvent } from '../../utils/ServerSideEventConsumer';
import './RefreshButton.css';
import { HlsAudioPlayer } from "../../utils/HlsAudioPlayer";

interface RefreshButtonProps {
  refresh: () => Promise<void>;
  hlsAudioPlayer: HlsAudioPlayer;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({ refresh, hlsAudioPlayer }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    hlsAudioPlayer.pause();
    setIsRefreshing(true);
    try {
      refresh();
    } catch (error) {
      console.error('Error refreshing:', error);
    } finally {

    }
  };

  const statusCallback = (streamEvent: EventData) => {
    if (streamEvent.eventType === "operation-status") {
      const statusEvent: OperationStatusEvent = streamEvent as OperationStatusEvent;
      if (statusEvent.description.toLowerCase() === 'refresh' && statusEvent.subtask.toLowerCase() === 'all' && statusEvent.percent === 100) {
        setIsRefreshing(false);
      }
    }
  };

  useEffect(() => {
    sseConsumer.registerCallback("operation-status", statusCallback);
    return () => {
      sseConsumer.removeCallback("operation-status", statusCallback);
    };
  }, []);

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        handleRefresh();
      }}
      className="p-1 ml-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`h-8 w-8 ${isRefreshing ? 'refresh-spin' : ''}`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
    </button>
  );
};

export default RefreshButton;